import { BingMap } from './bing-map';

export const ActionTypes = {
  locationsChanged: 'LOCATIONS_CHANGED',
  mapsApiLoaded: 'MAPS_API_LOADED',
};

export const initialState = {
  bingMap: null,
};

export function bingMapsViewReducer(state, action) {
  if (action.type === ActionTypes.mapsApiLoaded) {
    const bingMap = new BingMap(action);

    // set the initial location targets and zoom to fit them into view
    bingMap.setLocationTargets(action).then(() => {
      bingMap.zoomToFit();
    });

    return { ...state, bingMap };
  } else if (action.type === ActionTypes.locationsChanged) {
    const { bingMap } = state;
    if (bingMap) {
      // update the location targets and then zoom to fit them all into view
      bingMap.setLocationTargets(action).then(() => {
        bingMap.zoomToFit();
      });
    }
  }

  return state;
}
